import { Box, Typography } from "@mui/material";
import React from "react";
import globalStyles from "../global";
import { useTranslation } from "react-i18next";
import News from "../components/globalCountries/countryhomepagescomponent/News";
import Stats from "../components/HomeComponent/Stats";
import GlobalPromise from "../components/HomeComponent/globalpromise";

const SupportSystem = () => {
  const { t } = useTranslation();

  const investmentTitle = t("homePage.supportSystem.investmentTitle");
  const investmentDescription = t(
    "homePage.supportSystem.investmentDescription"
  );
  const supportServices = [
    {
      id: "01",
      title: t("homePage.supportSystem.projectSupport.title"),
      description: t("homePage.supportSystem.projectSupport.description"),
    },
    {
      id: "02",
      title: t("homePage.supportSystem.operationsSupport.title"),
      description: t("homePage.supportSystem.operationsSupport.description"),
    },
    {
      id: "03",
      title: t("homePage.supportSystem.ecoConscious.title"),
      description: t("homePage.supportSystem.ecoConscious.description"),
    },
    {
      id: "04",
      title: t("homePage.supportSystem.supplyChain.title"),
      description: t("homePage.supportSystem.supplyChain.description"),
    },
    {
      id: "05",
      title: t("homePage.supportSystem.techSupport.title"),
      description: t("homePage.supportSystem.techSupport.description"),
    },
    {
      id: "06",
      title: t("homePage.supportSystem.marketingSupport.title"),
      description: t("homePage.supportSystem.marketingSupport.description"),
    },
  ];

  return (
    <Box>
      <Stats sx={{ marginBottom: styles.sectionMarginBottom , }} />
      <Box
        sx={{
          ...styles.contentWrapper,
          marginBottom: styles.sectionMarginBottom,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <GlobalPromise />
      </Box>

      {/* Investment Section */}
      <Box sx={{ ...styles.investmentSection ,   
    }}>
        <Typography
          variant="h1_gothic"
          sx={{
            textAlign: "center",
            marginBottom: { xs: "16px", sm: "24px", md: "32px" },
            color: globalStyles.colors.army_green,
            fontSize: {
              xs: "24px",
              sm: "38px",
              md: "40px",
            },
           
          fontWeight: "400",
            width: "100%", // Added width: 100%
            display: "block", // Added display: block
          }}
        >
          {investmentTitle}
        </Typography>
        <Typography variant="body2" sx={styles.investmentDescription}>
          {investmentDescription}
        </Typography>
      </Box>

      {/* Existing Support Services Section */}
      <Box sx={{ ...styles.mainServiceContainer, width: "100%" }}>
        <Typography
          variant="h1_gothic"
          sx={{
            textAlign: "center",
            marginBottom: { xs: "16px", sm: "24px", md: "32px" },
            color: globalStyles.colors.white,
             fontSize: {
              xs: "24px",
              sm: "38px",
              md: "40px",
            },
           
          fontWeight: "400",
            fontFamily: globalStyles.fonts.primaryGlobal,
            width: "100%", // Added width: 100%
            display: "block", // Added display: block
          }}
        >
          {t("homePage.supportSystem.supportSystemTitle")}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            textAlign: "center",
            marginBottom: { xs: "18px", sm: "30px", md: "42px" },
            color: globalStyles.colors.white,
            fontSize: {
      xs: "10px",
      sm: "15px",
      md: "22px",
    },
            maxWidth: {
              xs: "98%",
              sm: "85%",
              md: "73%",
              lg: "65%",
            },
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          {t("homePage.supportSystem.supportSystemDescription")}
        </Typography>
        <Box
          sx={{
            ...styles.mainContainer,
            marginBottom: styles.sectionMarginBottom,
          }}
        >
          <Box sx={styles.servicesGrid}>
            {supportServices.map((service) => (
              <Box key={service.id} sx={styles.serviceCard}>
                <Box sx={styles.serviceNumberRight}>{service.id}</Box>
                <Typography sx={styles.serviceTitle}>
                  {service.title}
                </Typography>
                <Typography sx={styles.serviceDescription}>
                  {service.description}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
      <News />
    </Box>
  );
};

const styles = {
  mainContainer: {
    width: { xs: "89%", sm: "85%", md: "62%" },
    margin: "auto",
  },
  mainServiceContainer: {
    width: { xs: "100%", sm: "85%", md: "62%" },
    margin: "auto",
    paddingY: { xs: "20px", sm: "40px", md: "64px" },
    backgroundColor: globalStyles.colors.army_green,
  },
  servicesGrid: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "1fr 1fr",
      md: "1fr 1fr 1fr",
    },
    gap: {
      xs: "16px",
      sm: "24px",
      md: "32px",
    },
    marginTop: {
      xs: "16px",
      sm: "24px",
      md: "32px",
    },
  },
  serviceCard: {
    backgroundColor: globalStyles.colors.white,
    padding: {
      xs: "16px",
      sm: "20px",
      md: "24px",
    },
    borderRadius: "12px",
    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
    minHeight: {
      xs: "65px",
      sm: "90px",
      md: "120px",
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    position: "relative",
    maxWidth: {
      xs: "100%",
      sm: "100%",
      md: "340px",
    },
  },
  serviceNumberRight: {
    fontSize: {
      xs: "38px",
      sm: "48px",
      md: "80px",
    },
    color: "rgba(0, 0, 0, 0.1)",
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 900,
    textAlign: "right",
    marginBottom: "8px",
    alignSelf: "flex-end",
    width: "100%",
  },
  serviceTitle: {
    fontSize: {
      xs: "14px",
      sm: "18px",
      md: "22px",
    },
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 600,
    color: globalStyles.colors.army_green,
    marginBottom: "8px"
  },
  serviceDescription: {
    fontSize: {
      xs: "10px",
      sm: "12px",
      md: "14px",
    },
    fontFamily: '"Poppins", sans-serif',
    color: globalStyles.colors.uclean_medium_gray,
    maxWidth: "300px",
    whiteSpace: "pre-line",
    marginLeft: 0,
    marginRight: 0,
  },
  investmentSection: {

    width: { xs: "100%", sm: "100%", md: "100%" },
    margin: "auto",
    paddingY: { xs: "32px", sm: "48px", md: "80px" },
    backgroundColor: "rgba(0, 100, 0, 0.05)",
  },
  investmentTitle: {
    fontSize: {
      xs: "18px",
      sm: "24px",
      md: "32px",
    },
    fontFamily: globalStyles.fonts.primaryGlobal,
    fontWeight: 600,
    color: globalStyles.colors.army_green,
    textAlign: "center",
        marginLeft: "auto",
    marginRight: "auto",
     maxWidth: {
      xs: "98%",
      sm: "70%",
      md: "52%",
      lg: "46%",
    },
  },
  investmentDescription: {
    fontSize: {
      xs: "10px",
      sm: "15px",
      md: "22px",
    },
    textAlign: "center",
    color: globalStyles.colors.uclean_medium_gray,
    maxWidth: {
      xs: "98%",
      sm: "70%",
      md: "52%",
      lg: "46%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },
  contentWrapper: {
    maxWidth: "100vw",
    margin: "0 auto",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: {
      xs: "16px",
      md: "40px",
    },
    padding: { xs: "16px", md: 0 },
    alignItems: "center",
    justifyContent: "center",
  },
  sectionMarginBottom: {
    xs: "24px",
    sm: "48px",
    md: "96px",
  },
};

export default SupportSystem;